import { axios } from '@/utils/request'

const api = {
    cpjlgradelist: '/adminapi/cha/cpjlgradelist', 
    kgjdgradelist: '/adminapi/cha/kgjdgradelist', 
 
}

export default api

export function cpjlgradelist(parameter) {
  return axios({
    url: api.cpjlgradelist,
    method: 'get',
    params: parameter
  })
}
 
export function kgjdgradelist(parameter) {
  return axios({
    url: api.kgjdgradelist,
    method: 'get',
    params: parameter
  })
}
 